import React, {PropTypes} from 'react';
import { InvoiceService } from 'frilans-finans';
import RegisteredOrdersTitle from './registered-orders-title';
import RegisteredOrdersTable from './registered-orders-table';

export class RegisteredOrders extends React.Component {
  static propTypes = {
    user: PropTypes.object.isRequired
  };

  constructor () {
    super();

    this.state = {
      fetching: true,
      fetchError: false,
      invoices: [],
      pendingRequest: null,
      meta: {
        total: 0
      }
    };

    this.fetchInvoices = this.fetchInvoices.bind(this);
    this.removeInvoiceFromState = this.removeInvoiceFromState.bind(this);
  }

  componentDidMount () {
    this.fetchInvoices();
  }

  fetchInvoices () {
    this.setState({
      fetching: true
    });

    const userId = +this.props.user.id;

    let pendingRequest = InvoiceService.get(userId, null, 1, 1, null, 2);

    pendingRequest.promise
      .then(this.handleResponse.bind(this))
      .catch(error => {
        if (error.response !== undefined) {
          this.setState({
            fetchError: true
          });
        }
      });

    this.setState({
      pendingRequest: pendingRequest
    });
  }

  handleResponse (response) {
    this.setState({
      fetching: false,
      fetchError: false,
      invoices: response.collection,
      meta: response.meta
    });
  }

  removeInvoiceFromState (invoiceId) {
    this.setState({
      invoices: this.state.invoices.filter((invoice) => +invoice.id !== invoiceId)
    });
  }

  render () {
    return this.state.invoices.length
      ? (<div className='registered-orders-wrapper'>
        <RegisteredOrdersTitle total={this.state.meta.total} />
        <RegisteredOrdersTable
          invoices={this.state.invoices}
          removeInvoiceFromState={this.removeInvoiceFromState}
          user={this.props.user}
        />
      </div>)
      : null;
  }
}

export default RegisteredOrders;



/** WEBPACK FOOTER **
 ** ./src/components/registered-orders/registered-orders.js
 **/